var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMilestone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 169,
    viewBox: "0 0 169 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_296_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169 0H0V169H169V0Z",
    fill: "url(#pattern0_296_45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 60H55.8333C53.6232 60 51.5036 60.878 49.9408 62.4408C48.378 64.0036 47.5 66.1232 47.5 68.3333V80.8333C47.5 83.0435 48.378 85.1631 49.9408 86.7259C51.5036 88.2887 53.6232 89.1667 55.8333 89.1667H110L126.667 74.5833L110 60Z",
    stroke: "black",
    strokeWidth: 16.6667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 89.1665V122.5",
    stroke: "black",
    strokeWidth: 16.6667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 47.5V60",
    stroke: "black",
    strokeWidth: 16.6667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_296_45",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_296_45",
    transform: "scale(0.00591716)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_296_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 169,
    height: 169,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_296_45",
    width: 169,
    height: 169,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestone);
export default __webpack_public_path__ + "static/media/milestone.50286836832df80c2fc2a6e1b46121f0.svg";
export { ForwardRef as ReactComponent };